enum ConnectionStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

export default ConnectionStatus;
